'use strict';

var novicell = novicell || {};

novicell.tableSpot = novicell.tableSpot || new function () {

  // Freeze first column
  function tbodyTheadFirstFreezeColumn(tableSpot) {
    let scrollLeft = tableSpot.scrollLeft;
    // Thead column freeze
    let first_thead = tableSpot.querySelector('thead th:nth-child(1)');
    first_thead.style.transform = 'translateX(' + scrollLeft + 'px)';
    if (scrollLeft === 0) {
      first_thead.classList.remove('first-column-scroll-active');
    } else {
      first_thead.classList.add('first-column-scroll-active');
    }
    // Tbody column freeze
    let tbody_firsts = tableSpot.querySelectorAll('tbody td:nth-child(1)');
    for (let i = 0; i < tbody_firsts.length; i++) {
      let first_tbody_element = tbody_firsts[i];
      first_tbody_element.style.transform = 'translateX(' + scrollLeft + 'px)';
      if (scrollLeft === 0) {
        first_tbody_element.classList.remove('first-column-scroll-active');
      } else {
        first_tbody_element.classList.add('first-column-scroll-active');
      }
    }
  }

  // Check if we have reached the horizontal end of scroll element
  function reachedEndOfScroll(tableSpot) {
    let scrollLeft = tableSpot.scrollLeft;
    let width = tableSpot.clientWidth;
    let scrollWidth = tableSpot.scrollWidth;
    return scrollWidth - scrollLeft === width;
  }

  // Move gradient to the right
  function showHideGradintRight(tableSpot) {
    let gradientRight = tableSpot.querySelector('.js-table-spot-gradient-right');
    gradientRight.style.transform = 'translateX(' + tableSpot.scrollLeft + 'px)';
    if (reachedEndOfScroll(tableSpot)) {
      gradientRight.classList.remove('table-spot__gradient-right--active');
    } else {
      gradientRight.classList.add('table-spot__gradient-right--active');
    }
  }

  // Looping over all table spots, putting in a function so we wont rewrite it more than once
  function loopOverTableSpots(tableSpots, scroll, resize) {
    for (let i = 0; i < tableSpots.length; i++) {
      let tableSpot = tableSpots[i].querySelector('.js-table-spot-content');
      if (tableSpot.clientWidth !== tableSpot.scrollWidth) {
        tableSpot.querySelector('.js-table-spot-gradient-right').classList.add('table-spot__gradient-right--active');
      }
      if (scroll) {
        tableSpot.addEventListener('scroll', function () {
          let self = this;
          showHideGradintRight(self);
          tbodyTheadFirstFreezeColumn(self);
        }, {passive: true});
      } else if (resize) {
        showHideGradintRight(tableSpot);
      }
    }
  }

  this.init = function () {
    let tableSpots = document.querySelectorAll('.js-table-spot');
    if (tableSpots.length) {
      loopOverTableSpots(tableSpots, true, false);
      window.addEventListener('resize', function () {
        loopOverTableSpots(tableSpots, false, true);
      }, {passive: true});
    }
  };
}();